<template>
  <modal :show="show" :large="true" v-on:close="closeModal">
    <div slot="title">
      <h4>Generate Document</h4>
    </div>
    <div class="row">
      <div class="col-xl-12">
        <hire-vehicle-agreement-form
          :incident="incident.identifier"
          :hire="hire"
          :form="form"
          v-if="!hire.hire_agreement"
        ></hire-vehicle-agreement-form>

        <div class="text-center" v-else>
          <p>The hire agreement has already been generated.</p>

          <div
            class="gutter-top"
            v-if="hasPermission('hires.regenerateDocuments')"
          >
            <p>
              To regenerate the hire agreement
              <a class="cursor-pointer" @click="clearHireAgreement"
                >click here.</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" v-if="!hire.hire_agreement">
      <button type="button" v-on:click="closeModal" class="btn btn-danger">
        Close
      </button>
      <form-button :indicator="form.processing()" @clicked="generate">
        Generate Document
      </form-button>
    </div>
  </modal>
</template>

<script>
import HireVehicleAgreementForm from '@/components/Modules/Deployment/Children/Children/Children/HireVehicleAgreementForm';

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    incident: {
      type: Object,
      required: true
    },
    hire: {
      type: Object,
      required: true
    }
  },

  components: {
    HireVehicleAgreementForm
  },

  mounted() {},

  data() {
    return {
      form: new window.Form({
        excess: null,
        other_excess: null,
        description: null,
        placeholders: []
      })
    };
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
    generate() {
      this.form
        .post(`/hires/${this.hire.identifier}/hire-agreement`)
        .then(response => {
          this.hire.hire_agreement = response;
          console.log(this.hire.hire_agreement);
          this.$emit('generated', response);

          window.toastify.success(
            'Saved',
            "We've successfully generated the hire agreement"
          );

          this.form.reset();
        })
        .catch(err => {
          this.indicator = false;
          window.toastify.error(
            'Error',
            "Sorry, we couldn't generate the document. Please try again"
          );
        });
    },

    clearHireAgreement() {
      this.hire.hire_agreement = null;
    }
  }
};
</script>
